import about_us_bg from './about_us_bg.png';
import about_us_sect_2 from './about_us_sect_2.png';
import browser_1 from './browser_1.png';
import core_sales from './core_sales.png';
import hero_bg_1 from './hero_bg_1.webp';
import hero_bg_2 from './hero_bg_2.webp';
import hero_bg_3 from './hero_bg_3.webp';
import hero_bg_4 from './hero_bg_4.webp';
import hero_bg_5 from './hero_bg_5.webp';
import hero_browser from './hero_browser.webp';
import hero_mobile from './hero_mobile.webp';
import hero_why_lfg from './hero_why_lfg.png';
import hex_1 from './hex_1.png';
import hex_2 from './hex_2.png';
import how_it_work_bg from './how_it_work_bg.png';
import orbit_medal from './orbit_medal.png';
import our_vision_bg from './our_vision_bg.png';
import our_vision_bg_mobile from './our_vision_bg_mobile.png';
import subtract_2_splash from './subtract_2_splash.svg';
import subtract_3 from './subtract_3.svg';
import team_card_bg from './team_card_bg.png';
import why_lfg_bg from './why_lfg_bg.png';

export const backgrounds = {
  browser_1: browser_1.src,
  hero_bg_1: hero_bg_1.src,
  hero_bg_2: hero_bg_2.src,
  hero_bg_3: hero_bg_3.src,
  hero_bg_4: hero_bg_4.src,
  hero_bg_5: hero_bg_5.src,
  hero_browser: hero_browser.src,
  hero_mobile: hero_mobile.src,
  how_it_work_bg: how_it_work_bg.src,
  subtract_2_splash,
  subtract_3,
  why_lfg_bg: why_lfg_bg.src,
  hero_why_lfg: hero_why_lfg.src,
  hex_1: hex_1.src,
  hex_2: hex_2.src,
  team_card_bg: team_card_bg.src,
  about_us_bg: about_us_bg.src,
  about_us_sect_2: about_us_sect_2.src,
  core_sales: core_sales.src,
  orbit_medal: orbit_medal.src,
  our_vision_bg: our_vision_bg.src,
  our_vision_bg_mobile: our_vision_bg_mobile.src,
};
